export default __webpack_public_path__ + "static/media/on-time.9188bb30.png";